import { getFrontendFeatureFlag } from './frontendConfig';

/**
 * Wizards masivos: en producción quedan ocultos salvo admin/category (isAdminMod / isCategory).
 * En otros entornos se puede habilitar para todos vía FrontendFeatures en appsettings.
 */
export const canShowCreacionMasivaWizard = (userType) => {
    const roleOk = Boolean(userType?.isAdminMod || userType?.isCategory);
    const flagOk = getFrontendFeatureFlag(['publicaciones', 'showCreacionMasivaWizard'], false);
    return roleOk || flagOk;
};

export const canShowActualizacionMasivaWizard = (userType) => {
    const roleOk = Boolean(userType?.isAdminMod || userType?.isCategory);
    const flagOk = getFrontendFeatureFlag(['publicaciones', 'showActualizacionMasivaWizard'], false);
    return roleOk || flagOk;
};
